import { render } from "./UserDept.vue?vue&type=template&id=4b505e0a&scoped=true"
import script from "./UserDept.vue?vue&type=script&setup=true&lang=js"
export * from "./UserDept.vue?vue&type=script&setup=true&lang=js"

import "./UserDept.vue?vue&type=style&index=0&id=4b505e0a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b505e0a"],['__file',"src/pages/users/UserDept.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4b505e0a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4b505e0a', __exports__)) {
    console.log('reload')
    api.reload('4b505e0a', __exports__)
  }
  
  module.hot.accept("./UserDept.vue?vue&type=template&id=4b505e0a&scoped=true", () => {
    console.log('re-render')
    api.rerender('4b505e0a', render)
  })

}


export default __exports__